import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Chip } from "@mui/material";
import { useGetOne } from "react-admin";
export var AreaItem = function (props) {
    var record = props.record;
    var data = useGetOne("sequent_backend_area", { id: record }).data;
    return _jsx(_Fragment, { children: data ? _jsx(Chip, { label: data === null || data === void 0 ? void 0 : data.name }) : null });
};
